package horcrux.frontend.common

import horcrux.frontend.common.analytics.PageViewEvent
import horcrux.frontend.common.configs.ApplicationConfigs
import horcrux.common.RenderingLocation
import js.objects.jso
import kotlinx.browser.window
import react.FC
import react.Props
import react.create
import react.dom.html.ReactHTML.div
import react.router.NavigateFunction
import react.router.RouteObject

enum class Route(val routeName: String, val viewName: String) {
    LANDING_PAGE("/", "Landing Page"),
    CHAT_WITH_YOUR_COLLECTION("/chat-with-your-collection", "Chat With Your Collection"),
    CONTACT_US("/contact-us", "Contact Us"),
    LATEST_NEWS("/latest-news", "Latest News"),
    PRIVACY_POLICY("/privacy-policy", "Privacy Policy"),
    ERROR_BOUNDARY("/error-screen", "Error Screen");

    val pageViewEvent: PageViewEvent by lazy { PageViewEvent(this) }

    val withHash: String
        get() = "#${this.routeName}"

    val fullURL: String
        get() {
            val hostURL = when {
                ApplicationConfigs.RENDERING_LOCATION == RenderingLocation.CLIENT && isBrowserEnvironment() -> window.location.origin
                else -> ApplicationConfigs.FRONTEND_URL
            }
            return "$hostURL/web-app.html$withHash"
        }

    fun shouldShowCollectionNavigatorButton(): Boolean = listOf(CHAT_WITH_YOUR_COLLECTION).contains(this)

    fun navigate(navigate: NavigateFunction) =
        navigate(routeName)
}


fun <P : Props> RouteObject(route: Route, fc: FC<P>, block: P.() -> Unit = {}): RouteObject =
    jso {
        this.path = route.routeName
        this.element = div.create {
            fc {
                block(this)
            }
        }
    }
